/**
 * Build withdrawal transaction for withdrawing SOL from user's PDA account
 * This is a temporary solution until backend API is ready
 */

import { PublicKey, SystemProgram, TransactionInstruction } from '@solana/web3.js';
import * as anchor from '@coral-xyz/anchor';

import { getProgramReadOnly, getEventAuthorityPDA } from './anchorClient';

export async function buildWithdrawTransaction(
  walletPublicKey: PublicKey,
  amountLamports: bigint
): Promise<TransactionInstruction[]> {
  const program = getProgramReadOnly();

  // Get PDA addresses
  const [globalConfig] = PublicKey.findProgramAddressSync(
    [Buffer.from("global_config")],
    program.programId
  );

  const [userInfo] = PublicKey.findProgramAddressSync(
    [Buffer.from("user_info"), walletPublicKey.toBuffer()],
    program.programId
  );

  const [eventAuthority] = getEventAuthorityPDA();

  // Build withdraw instruction
  // Convert bigint to BN for Anchor
  const amountStr = amountLamports.toString();
  const amountBN = new anchor.BN(amountStr);

  // Pass the BN object directly - Anchor expects BN, not a number
  const withdrawIx = await program.methods
    .depositOrWithdraw(
      false, // isDeposit = false (withdraw)
      amountBN // Pass BN object, not number
    )
    .accounts({
      user: walletPublicKey,
      globalConfig: globalConfig,
      userInfo: userInfo,
      systemProgram: SystemProgram.programId,
      eventAuthority: eventAuthority,
      program: program.programId,
    })
    .instruction();

  return [withdrawIx];
}